import { tokens } from "shared/components/Spor";
import { appPalette } from "shared/theme/colors/appPalette";
import { mapValues } from "shared/utils/arrayUtils";
// After SporV2 we need to retrieve the colors directly from palette
const { palette } = tokens.default.color;
const alias = mapValues(tokens.default.color.alias, (value) => {
  const [_, color, strength] = value.split(".");
  const paletteColor = (palette as any)[color];
  // Some aliases reference a single value (e.g. "colors.white") with no strength.
  return strength ? paletteColor[strength] : paletteColor;
});

const colors = {
  ...appPalette,
  ...palette,
  ...alias,
};

export default colors as unknown as {
  [K in keyof typeof colors]: string;
};
